import { startsWith } from 'lodash';

// eslint-disable-next-line consistent-return
const getHelperTextFromErrors = (errors) => {
  if (!errors || errors.length === 0) return void 0;
  if (errors.includes('required')) {
    return 'This field is required';
  } else if (errors.find((error) => startsWith(error, 'minLength'))) {
    const requiredLength = errors.find((error) => startsWith(error, 'minLength')).replace('minLength', '');
    return `Value must be longer than ${requiredLength} characters`;
  } else if (errors.includes('invalid mobile')) {
    return 'Invalid mobile number';
  } else if (errors.includes('invalid email')) {
    return 'Invalid email address';
  } else if (errors.includes('invalid gennumber')) {
    return 'Invalid GEN number';
  }
};

export default getHelperTextFromErrors;
